import { requestWithToken } from "../helpers/helpers";

const createIncome = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      "/cashbook/income",
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchIncomeReport = async (pageNo, pageSize, payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      `/cashbook/incomeReport?pageNo=${pageNo}&pageSize=${pageSize}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export { createIncome, fetchIncomeReport };
